import { FieldIcon } from "@/components/FieldIcon/FieldIcon";
import {
    getTextColourStyle,
    getTextStyle,
} from "@/components/PdfDocument/utils/getStyles";
import { GLOBAL_STYLE_KEY } from "@/constants/resume";
import { decodeHtml } from "@/pages/ResumeBuilder/utils";
import { ResumeStyles } from "@/types/resume";
import { insertBlankSpaceToEmptyTags } from "@/utils/string";

interface ReadOnlyBodyTextProps {
    value: string;
    icon?: string;
    stylesConfig: ResumeStyles;
    id: string;
    isStaticHeader?: boolean;
}

export const ReadOnlyBodyText = ({
    value,
    icon,
    stylesConfig,
    id,
    isStaticHeader,
}: ReadOnlyBodyTextProps) => {
    const decodedValue = decodeHtml(value);
    const textStyle = getTextStyle(
        stylesConfig?.[GLOBAL_STYLE_KEY]?.fontSize ?? "",
        "p",
        false,
    );
    const textColourStyle = getTextColourStyle({
        accentColor: stylesConfig?.[GLOBAL_STYLE_KEY]?.themeColor ?? "",
        isStaticHeader,
        fieldKey: id,
    });
    const valueWithSpaces = insertBlankSpaceToEmptyTags(decodedValue);
    return (
        <div className="ProseMirror flex flex-row items-start">
            {icon && (
                <FieldIcon
                    name={icon}
                    stylesConfig={stylesConfig}
                    isStaticHeader={!!isStaticHeader}
                />
            )}
            {decodedValue.startsWith("<p") ? (
                <div
                    style={{
                        ...textStyle,
                        ...textColourStyle,
                        wordBreak: "break-word",
                    }}
                    dangerouslySetInnerHTML={{ __html: valueWithSpaces }}
                />
            ) : (
                <p
                    style={{
                        ...textStyle,
                        ...textColourStyle,
                        wordBreak: "break-word",
                    }}
                    dangerouslySetInnerHTML={{
                        __html: valueWithSpaces ?? "",
                    }}
                />
            )}
        </div>
    );
};
